"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/Finish/components/SecondaryDownloads/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _qrcodereact = require('qrcode.react');







var _app = require('web/services/app');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _urls = require('web/services/urls');




var _onboardingAnalytics = require('web/services/onboardingAnalytics');













 const computePlatformInfo = () => {
  const appMode = _app.getAppMode.call(void 0, )
  const isElectron = appMode === _app.ELECTRON_CHAT_MODE
  const isMobileBrowser = appMode === _app.MWEB_CHAT_MODE

  const desktopOs = _app.getDesktopOs.call(void 0, )
  const hasDesktopInstaller = desktopOs === 'mac' || desktopOs === 'windows'
  const desktopDownloadUrl = _app.getDesktopDownloadUrl.call(void 0, )
  const desktopOsLabel = desktopOs === 'mac' ? 'Mac' : 'Windows'

  return {
    appMode,
    isElectron,
    isMobileBrowser,
    hasDesktopInstaller,
    desktopDownloadUrl,
    desktopOsLabel,
  }
}; exports.computePlatformInfo = computePlatformInfo

const QR_DESCRIPTION = 'Scan with your phone to download the BloomText mobile app.'
// The stacked cards have room for one short line under each title.
const QR_DESCRIPTION_SHORT = 'Scan to get the mobile app'

 const QrSection = ({
  downloadUrl,
  description = QR_DESCRIPTION,
}) => (
  _react2.default.createElement('section', { className: "signup-finish--qr-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
    , _react2.default.createElement('div', { className: "signup-finish--qr-code", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      , _react2.default.createElement(_qrcodereact.QRCodeSVG, { value: downloadUrl, size: 160, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} )
    )
    , _react2.default.createElement('div', { className: "signup-finish--qr-section--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
      , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Get it on your phone"    )
      , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  description )
    )
  )
); exports.QrSection = QrSection











/**
 * The platform-aware app-download affordances (mobile smart-link CTA / desktop
 * installer + QR / Electron-and-Linux QR), extracted from `FinishSection` so both
 * the pre-login finish screen and the Phase 7 guided finish surface render the
 * same download UI. Preserves the attributed smart-link URL and the existing
 * download click events (`SIGN_UP_DOWNLOAD_CLICKED` + `app_download_clicked`).
 */
const SecondaryDownloads = ({ surface = 'signup_finish', layout = 'row' }) => {
  const platform = _react.useMemo.call(void 0, () => exports.computePlatformInfo.call(void 0, ), [])
  const attributedAppSmartLinkUrl = _react.useMemo.call(void 0, 
    () => _onboardingAnalytics.buildAppDownloadUrlWithAttribution.call(void 0, _urls.appSmartLinkUrl),
    [],
  )

  const trackDownloadClick = (target) => {
    _amplitude2.default.logEvent('SIGN_UP_DOWNLOAD_CLICKED', {
      surface,
      target,
      app_mode: platform.appMode,
      is_electron: platform.isElectron,
      is_mobile_browser: platform.isMobileBrowser,
      desktop_os: target === 'desktop_installer' ? platform.desktopOsLabel : undefined,
    })
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.APP_DOWNLOAD_CLICKED, {
      app_mode: platform.appMode,
      platform: 'web',
      download_target: target,
      surface,
    })
  }

  if (platform.isMobileBrowser) {
    return (
      _react2.default.createElement('a', {
        href: attributedAppSmartLinkUrl,
        onClick: () => trackDownloadClick('mobile_smart_link'),
        className: "blm-btn blm-btn--primary signup-finish--cta-primary signup-finish--store"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
, "Get the App"

      )
    )
  }

  // Electron (already on desktop) and desktops with no published installer
  // (e.g. Linux) both get the phone-only variant — no misleading desktop CTA.
  const isStacked = layout === 'stacked'
  const qrDescription = isStacked ? QR_DESCRIPTION_SHORT : QR_DESCRIPTION
  const tilesClassName = isStacked
    ? 'signup-finish--tiles signup-finish--tiles--stacked'
    : 'signup-finish--tiles'

  if (platform.isElectron || !platform.hasDesktopInstaller) {
    const qr = _react2.default.createElement(exports.QrSection, { downloadUrl: attributedAppSmartLinkUrl, description: qrDescription, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}} )
    return isStacked ? _react2.default.createElement('div', { className: tilesClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}},  qr ) : qr
  }

  // Desktop with an installer: the download and the phone QR side by side.
  return (
    _react2.default.createElement('div', { className: tilesClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
      , _react2.default.createElement('a', {
        href: platform.desktopDownloadUrl,
        onClick: () => trackDownloadClick('desktop_installer'),
        className: "signup-finish--tile", __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}

        , _react2.default.createElement('span', { className: "auth-icon-circle signup-finish--tile-icon" , 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
          , _react2.default.createElement('svg', { viewBox: "0 0 24 24"   , width: "22", height: "22", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
            , _react2.default.createElement('path', { d: "M12 4v12M6 11l6 6 6-6M5 20h14"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}} )
          )
        )
        , _react2.default.createElement('span', { className: "signup-finish--tile-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
          , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}, `Download for ${platform.desktopOsLabel}`)
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}, "Desktop app with notifications"   )
        )
      )
      , _react2.default.createElement(exports.QrSection, { downloadUrl: attributedAppSmartLinkUrl, description: qrDescription, __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}} )
    )
  )
}

exports. default = SecondaryDownloads
